/**
 * ToolbarButton Component
 *
 * Standard button for toolbar actions.
 */

import type { ReactNode } from 'react';
import clsx from 'clsx';

export interface ToolbarButtonProps {
  icon?: ReactNode;
  label: string;
  isActive?: boolean;
  onClick?: () => void;
  count?: number;
}

export function ToolbarButton({ icon, label, isActive, onClick, count }: ToolbarButtonProps) {
  return (
    <button
      onClick={onClick}
      className={clsx(
        'flex items-center gap-1.5 px-2 py-1 text-[10px] sm:px-2.5 sm:py-1.5 sm:text-[11px] rounded-lg font-medium transition-all',
        isActive
          ? 'bg-accent-violet-dim text-accent-violet'
          : 'text-text-tertiary hover:text-text-secondary hover:bg-surface-hover'
      )}
    >
      {icon}
      <span className="hidden sm:inline">{label}</span>
      {count !== undefined && count > 0 && (
        <span className="px-1.5 py-0.5 rounded-full bg-surface-tertiary text-[9px] font-semibold tabular-nums">
          {count}
        </span>
      )}
    </button>
  );
}
